module.exports = __webpack_public_path__ + "images/pages/for_business/pc/s_icon01_864c8619544845c7fc9fc2fd2432f8c7.png";